import { ClipboardAlertIcon } from './ClipboardAlertIcon';

/**
 * author: Google
 * id 57AC4C5E-B2AB-42B5-9826-BCFEACCB2E7C
 * name clipboard-alert
 * version: 1.5.54
 * url https://raw.githubusercontent.com/Templarian/MaterialDesign/master/svg/clipboard-alert.svg
 * tags
 * - Alert / Error 
 */
export const ClipboardWarningIcon = ClipboardAlertIcon;
export default ClipboardWarningIcon